<template>
  <v-container>
    <div id="pagos-sub-tab">
      <v-layout align-center justify-center>
        <v-flex lg12>
          <v-tabs v-model="active_tab">
            <v-tabs-slider color="blue"></v-tabs-slider>
            <v-tab
              v-for="(tab, index) in tabs"
              :key="index"
              @click="selected(tab)"
            >
              {{ tab }}
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="active_tab">
            <!-- Pestaña pagos-->
            <v-tab-item>
              <pagos-multas-select-nuevo  
                v-if="tabSelected === 'Pagos'"
                :show="true"
              ></pagos-multas-select-nuevo>
            </v-tab-item> 
            <v-tab-item>
              <ingreso-multas-select-nuevo  
                v-if="tabSelected === 'Multas'"
                :show="true"
              ></ingreso-multas-select-nuevo>
            </v-tab-item> 
            <!-- Pestaña Consulta Multas -->
             <v-tab-item>
              <detalle-multa
                v-if="tabSelected === 'Consulta Multas'"
                :show="true"
                tipeView="consulta"
              ></detalle-multa>
            </v-tab-item> 
            <!-- Pestaña Consulta Pagos -->
            <v-tab-item>
              <detalle-pago
                v-if="tabSelected === 'Consulta Pagos'"
                :show="true"
                tipeView="consulta"
              ></detalle-pago>
            </v-tab-item> 
          </v-tabs-items>
        </v-flex>
      </v-layout>
    </div>
  </v-container>
</template>

<script>
import jwtDecode from "jwt-decode";
import PagosMultasSelectNuevo from "@/modules/configuration/pagosymultasnuevo/PagosMultasSelectNuevo.vue";
import IngresoMultasSelectNuevo from "@/modules/configuration/pagosymultasnuevo/IngresoMultasSelectNuevo.vue";
import DetalleMulta from "@/modules/configuration/pagosymultas/views/pagosMultas/DetalleMulta.vue";
import DetallePago from "@/modules/configuration/pagosymultas/views/pagosMultas/DetallePago.vue";

export default {
  name: "pagos-sub-tab",
  components: {
    PagosMultasSelectNuevo,
    IngresoMultasSelectNuevo,
    DetalleMulta,
    DetallePago,
  },
  props: {
    tabse: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      // Lista de pestañas disponibles
      tabs: ["Pagos", "Multas","Consulta Multas", "Consulta Pagos"],
      // tabs: ["Pagos"],
      // Pestaña activa (por índice)
      active_tab: 0,
      // Texto de la pestaña seleccionada (para lógica interna)
      tabSelected: "",
      usuarioLoggedTipe: "",
      tipeView: "",
    };
  },
  created() {
    const token = localStorage.getItem("token");
      const decoded = jwtDecode(token);
      const user = decoded.dto;
      console.log("DECODED USER:", user);
    this.usuarioLoggedTipe = user.tipo;
    this.tipeView = this.$route.params.tipeView;
    // Si hay una pestaña almacenada en el store, se usa; sino, "Pagos" por defecto.
    let storedTab = this.$store.getters.subTabSelectedStored || "Consulta Multas";
    this.tabSelected = storedTab;
    // Se establece la pestaña activa según el índice de la pestaña seleccionada.
    this.active_tab = this.tabs.indexOf(storedTab);
  },
  methods: {
    selected(tab) {
      this.$store.commit("sub_tab_state", tab);
      this.tabSelected = tab;
      this.active_tab = this.tabs.indexOf(tab);
    },
  },
};
</script>
